import React from 'react';
import Container from '../../v2/container';
import ShipmentDetailsContainer from './ShipmentDetailsContainer';
const ShipmentDetailsFullPage = (props) => {
    return (React.createElement(Container, { className: "py-6", useMaxWidth: false },
        React.createElement(ShipmentDetailsContainer, Object.assign({}, props))));
};
export default ShipmentDetailsFullPage;
